import ko from 'knockout';
import templateMarkup from 'raw-loader!./realtime-alerts-view.html';

    function RealtimeAlertsView(params) {
        var self = this;

        self.route = params.route;
        self.dataProvider = params.dataProvider;
        self.tabId = 0;
    }

  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
  RealtimeAlertsView.prototype.dispose = function() { };
  
  export default { viewModel: RealtimeAlertsView, template: templateMarkup };


